module.exports = __webpack_public_path__ + "media/images/donation/logo-yuucho-d672f52647f050c89860e1c09975d145.jpg";